export default __webpack_public_path__ + "static/featured-image-ux-ui-design-45457971afd9d1d22fb09dfdc5bcdd08.jpg";